import React, { Component } from 'react'
import queryString from 'query-string'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons'

import DescriptionEditor from './DescriptionEditor'

import './Generator.css'


class Generator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      loading: true,
      error: null,
      title: null,
      description: null,
      text: null,
      requireAuth: true,
      mode: 'normal',
      choiceCounts: '5',
    };
  }

  componentDidMount() {
    const query = queryString.parse(window.location.search);
    if (query.generated) {
      this.setState({
        generated: query.generated,
        spreadsheet_url: `https://docs.google.com/spreadsheets/d/${query.spreadsheet_id}/edit`,
        task_url: `${window.location.href.split('?')[0]}?task_id=${query.task_id}`,
      });
      return;
    }
  }

  titleChange(event) {
    this.setState({
      title: event.target.value,
    })
  }

  descriptionChange(value) {
    this.setState({
      description: value,
    })
  }

  textChange(event) {
    this.setState({
      text: event.target.value,
    })
  }

  requireAuthChange(event) {
    this.setState({
      requireAuth: !event.target.checked,
    })
  }

  modeChange(event) {
    this.setState({
      mode: event.target.value,
    })
  }

  choiceCountsChange(event) {
    this.setState({
      choiceCounts: event.target.value,
    })
  }

  generate() {
    if (!this.props.onRequest) {
      return
    }
    this.props.onRequest(
      this.state.title,
      this.state.description || '',
      this.state.text,
      this.props.baseTaskDataId,
      this.state.requireAuth,
      this.state.mode,
      this.state.choiceCounts,
    )
  }

  render() {
    return <div className='Generator'>
      {this.state.generated ?
      <div className='Generator'>
        <h1>Cloze Testが作成されました！</h1>
        <p>
          Cloze Testの作成が完了しました。テストの実施は以下のURLから行うことができます。
        </p>
        <p>
          テストの記録は以下のGoogle Spreadsheetの [回答] シートに保存されます。
          テストの問題の編集、Cloze Testの更新も以下のSpreadsheetから行うことができます。<br/>
          詳しくは以下のSpreadsheetをご覧ください。
        </p>
        <div className='ResourceURL'>
          <a href={this.state.spreadsheet_url}>{this.state.spreadsheet_url}</a>
        </div>
      </div>
      : <div className='Generator'>
        <h1>Cloze Testエディタ</h1>
        <p>
          任意の英文からCloze Testや英単語クイズを作成することができます。<br/>
          以下のテキストボックスに英文を入力し、[Cloze Testを作成]ボタンを押してください！
        </p>
        {this.props.baseTaskDataId &&
          <div>
            インポート元タスク: {this.props.baseTaskDataId}
          </div>}
          <Form.Group>
            <Form.Label>タイトル</Form.Label>
            <Form.Control
              name='title'
              disabled={this.props.generating}
              placeholder='ここに英文のタイトルを入力してください。(必須)'
              onChange={ev => this.titleChange(ev)} />
          </Form.Group>
          <Form.Group>
            <Form.Label>説明</Form.Label>
            <DescriptionEditor
              disabled={this.props.generating}
              description={this.state.description}
              onChange={value => this.descriptionChange(value)}
            />
          </Form.Group>
          {!this.props.baseTaskDataId && <Form.Group>
            <Form.Label>文章</Form.Label>
            <Form.Control
              as='textarea'
              name='text'
              rows='20'
              disabled={this.props.generating}
              placeholder='ここに英語の文章を入力してください。'
              onChange={ev => this.textChange(ev)} />
          </Form.Group>}
          <Form.Group>
            <Form.Check
              type='checkbox'
              onChange={ev => this.requireAuthChange(ev)}
              label='認証なしでのアクセスを許可する' />
          </Form.Group>
          {!this.props.baseTaskDataId && <Form.Group>
            <Form.Label>Cloze Test空欄決定方法</Form.Label>
            <Form.Control as='select' onChange={ev => this.modeChange(ev)}>
              <option value='normal'>標準 - 品詞考慮・自由記述</option>
              <option value='normal-selection'>標準 - 品詞考慮・選択式</option>
              <option value='classic'>クラシック - 一定間隔</option>
            </Form.Control>
          </Form.Group>}
          <Form.Group>
            <Form.Label>空欄数</Form.Label>
            <Form.Control as='select' onChange={ev => this.choiceCountsChange(ev)}>
              {[...Array(6).keys()].map(cc => <option key={cc} value={cc + 5}>
                {cc + 5}語ずつ</option>)}
            </Form.Control>
          </Form.Group>
          <Button
            data-test-cloze-generate
            disabled={this.props.generating ||
              (!this.props.baseTaskDataId && (this.state.text === null || this.state.text.length === 0)) ||
              this.state.title === null || this.state.title.length === 0}
            onClick={() => this.generate()}
            variant='success'>
            <FontAwesomeIcon icon={faFileAlt} />
            {this.props.generating ? 'Cloze Testを作成中...' : 'Cloze Testを作成'}
          </Button>
          <div className='GenerateNotice'>
            登録したCloze Test問題は個人での利用にとどめてください。
          </div>
      </div>}
    </div>
  }
}

export default Generator;
